import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Program, PvWattsArrayType, PvWattsModuleType } from '@model';
import { GridProgramService, SolarPvService } from '@service';

/**
 * Interface for scenario form resolver data
 * Provides named properties instead of tuple indices for better type safety
 */
export interface ScenarioFormResolverData {
  arrayTypes: PvWattsArrayType[];
  moduleTypes: PvWattsModuleType[];
  programs: Program[];
}

/**
 * Scenario form resolver function (Angular 14+ functional API)
 * Replaces the deprecated class-based ScenarioFormResolver
 * 
 * @returns Observable of tuple [PvWattsArrayType[], PvWattsModuleType[], Program[]]
 * for backward compatibility with existing components
 */
export const scenarioFormResolver: ResolveFn<[PvWattsArrayType[], PvWattsModuleType[], Program[]]> = () => {
  const gridProgramService = inject(GridProgramService);
  const solarPvService = inject(SolarPvService);

  const allPrograms$ = gridProgramService.programs$();
  const arrayType$ = solarPvService.getPvWattsArrayType$();
  const moduleType$ = solarPvService.getPvWattsModuleType$();

  return forkJoin([arrayType$, moduleType$, allPrograms$]);
};
